// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__nG4Se","footerText":"styles_footerText__-+dku"};